import { z } from 'zod';

// 오늘 날짜를 로컬 시간 기준 YYYY-MM-DD 로 (date input 값과 같은 형식)
export function todayDateString(): string {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}

const quoteInquiryFields = z.object({
  title: z.string().min(1, '제목을 입력해주세요.'),
  company: z.string().min(1, '업체명을 입력해주세요.'),
  name: z.string().min(1, '이름을 입력해주세요.'),
  password: z.string().optional(),
  email: z.string().email('이메일 형식이 올바르지 않습니다.'),
  phone1: z.string().regex(/^01[0-9]$/, '연락처를 확인해주세요.'),
  phone2: z.string().regex(/^\d{3,4}$/, '연락처를 확인해주세요.'),
  phone3: z.string().regex(/^\d{4}$/, '연락처를 확인해주세요.'),
  shape: z.string().min(1, '패키지 형태를 입력해주세요.'),
  quantity: z
    .number({ invalid_type_error: '제작수량을 입력해주세요.' })
    .int()
    .min(1, '제작수량은 1개 이상이어야 합니다.'),
  boxSize: z.string().min(1, '박스 사이즈를 입력해주세요.'),
  contentSize: z.string().optional(),
  contentType: z.string().optional(),
  deadline: z.string().optional(),
  budget: z.string().optional(),
  print: z.string().optional(),
  route: z.string().optional(),
  content: z.string().min(1, '문의내용을 입력해주세요.'),
  reference: z.string().optional(),
  shippingMethod: z.enum(['SINGLE', 'BULK']),
  designType: z.enum(['NONE', 'HAVE']).optional(),
  agree: z.boolean().refine((v) => v === true, '개인정보 수집 및 이용에 동의해주세요.'),
});

export const quoteInquirySchema = quoteInquiryFields;

export type QuoteInquirySchema = z.infer<typeof quoteInquiryFields>;

// 로그인 상태에서는 회원 계정으로 문의가 귀속되므로 비밀번호가 필요 없고,
// 비회원 상태에서는 '주문조회'에서 확인할 수 있도록 비밀번호를 받아야 한다.
export function buildQuoteInquirySchema(requirePassword: boolean) {
  return quoteInquiryFields.superRefine((values, ctx) => {
    if (requirePassword && (!values.password || values.password.length < 4)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['password'], message: '비밀번호는 4자 이상 입력해주세요.' });
    }
    // 납기희망일은 오늘 이후만 가능
    if (values.deadline && values.deadline < todayDateString()) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['deadline'], message: '납기희망일은 오늘 이후 날짜로 선택해주세요.' });
    }
  });
}
